import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';

export class MaintenanceStrategyBoundaryDiagram implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Maintenance Strategy Boundary Diagram';
  readonly apiRoute: string = CONFIG.apiRoutes.maintenanceStrategyBoundaryDiagram;

  maintenanceStrategyBoundaryDiagramId: string;
  maintenanceStrategyId: string;
  header: string;
  base64EncodedImage: string;

  get image(): string {
    return `${this.header},${this.base64EncodedImage}`;
  }

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.maintenanceStrategyBoundaryDiagramId = data.maintenanceStrategyBoundaryDiagramId;
    this.header = data.header;
    this.base64EncodedImage = data.base64EncodedImage;
    this.maintenanceStrategyId = data.maintenanceStrategyId;
  }
}
